<template>
  <el-container class="main_container">
    <el-main :class="{'ismobilePhone':isMobilePhone}" style="height: 93vh;">
      <p @click="goBack" style="cursor: pointer;margin: -15px 0 0 0;">< Back</p>
      <div class="DataModule full_height">
        <div class="mod-demo" ref="homePage">
          <el-row :gutter="2" style="height:99%;">
            <el-col :span="6" style="height:100%;">
              <div class="container2">
                <div class="box left2">
                  <over-view :country='country' style="height: 100%;"></over-view>
                </div>
                <div class="box right2">
                  <p class="title">GDP/CPI/M2 YoY</p>
                  <echarts-view :country='country' style="top: -10px;left: 5px;"></echarts-view>
                </div>
              </div>
            </el-col>
            <el-col :span="18" style="height: 100%;">
              <el-row :gutter="2" style="height: 49%; margin-bottom: 1%;">
                <el-col :span="24" style="height: 100%">
                  <div class="box" style="float:left;width:100%;height:100%;">
                    <on-demand2 :isOk="isOk" :country='country'></on-demand2>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="2" style="height: 100%;">
                <el-col :span="24" style="height:100%;">
                  <div class="box" style="height:50%;width:100%;">
                    <el-col :sm="12" :md="15" :xl="18">
                      <interestView :country='country'></interestView>
                    </el-col>
                    <el-col :sm="12" :md="9" :xl="6" style="height: 100%;">
                      <financialView :country='country'></financialView>
                    </el-col>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-main>
  </el-container>

</template>

<script>
import overView from './components/dm/overView'
import echartsView from './components/dm/echartsView'
import interestView from './components/dm/interestView'
import financialView from './components/dm/financialView'
import OnDemand2 from './components/dm/OnDemand2'

export default {
  data() {
    return {
      isMobilePhone: false,
      clientHeight: '',
      isOk: true,
      countryCode: '',
      country: {}
    }
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function () {
      this.changeFixed(this.clientHeight)
    }
  },

  created() {
    this.country = {countryCode: this.getCountryCode(this.$route.params.countryCode), countryEn: this.$route.params.id}
  },
  components: {
    overView,
    echartsView,
    interestView,
    financialView,
    OnDemand2
  },
  methods: {
    goBack() {
      this.$router.push("/ChinaASEANInfo");
    },
    changeFixed(clientHeight) {
      // 动态修改样式
      //this.$refs.homePage.style.height = clientHeight + 'px'
    },
    initHeight() {  // 获取高度
      // 获取浏览器可视区域高度
      this.clientHeight = document.body.clientHeight
      window.onresize = () => {  // 当窗口或框架发生改变时触发
        this.clientHeight = document.body.clientHeight
      }
    },
    getCountryCode(countryCode) {
      const codeMap = new Map([['DM_BRU_MAIN', '1'], ['DM_TH_MAIN', '2'], ['DM_VNM_MAIN', '3'], ['DM_IDN_MAIN', '4'], ['DM_MAL_MAIN', '5'], ['DM_PHL_MAIN', '6'], ['DM_KHM_MAIN', '7'],
        ['DM_SG_MAIN', '8'], ['DM_LA_MAIN', '9'], ['DM_MMR_MAIN', '10']])
      return codeMap.get(countryCode)
    }
  }
}
</script>

<style scoped lang="scss">
body {
  overflow: hidden;
}

.mod-demo {
  min-width: 1364px;
  min-height: 597px;
  width: 100%;
  height: 100%;
  background-color: #ebecee;

  .box {
    border: #cfd1d8 1px solid;
    margin-left: 3px;
    margin-top: 3px;
    background-color: #fff;
  }
}

.container2 {
  position: relative;
  width: 100%;
  height: 100%;
}

.left2 {
  height: 49%;
  margin-bottom: 1%;
  width: 100%;
}

.right2 {
  position: absolute;
  width: 100%;
  top: 50%;
  bottom: 0;
  left: 0;
  .title {
    font-size: 16px;
    line-height: 2;
    color: rgb(64, 156, 249);
    margin: 4px 0 10px 0;
    padding-left: 10px;
    font-weight: 500;
    position: relative;
    border-bottom: 1px solid #dedede;
  }
  .title:after{
    content: '';
    width: 50px;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 30px;
    display: block;
    background-color: rgb(64, 156, 249);
  }
}

@media screen and (max-width: 1363px) {
  body {
    overflow: scroll;
  }
}

::-webkit-scrollbar,
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track-piece,
::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 5px;
}

::-webkit-scrollbar-thumb:vertical,
::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  background-color: #babdc6 !important;
  -webkit-border-radius: 5px;
}

::-webkit-scrollbar-thumb:horizontal,
::-webkit-scrollbar-thumb:horizontal {
  width: 3px;
  background-color: #babdc6 !important;
  -webkit-border-radius: 5px;
}

::-webkit-scrollbar-corner,
::-webkit-scrollbar-corner {
  background-color: #ebecee !important;
}
</style>
